export function buildEventMenuPath({
  organizationUuid,
  venueUuid,
  sectionName,
  row,
  seat,
  eventUuid,
}) {
  if (!organizationUuid || !sectionName) return null

  const params = new URLSearchParams()
  if (row) params.set('row', row)
  if (seat) params.set('seat', seat)
  if (eventUuid) params.set('event', eventUuid)

  const query = params.toString()
  const suffix = query ? `?${query}` : ''
  const encodedSection = encodeURIComponent(String(sectionName))

  if (venueUuid) {
    return `/menu/${organizationUuid}/${encodeURIComponent(String(venueUuid))}/${encodedSection}${suffix}`
  }

  return `/menu/${organizationUuid}/${encodedSection}${suffix}`
}

export function getSeatedTicketMenuSeat(tickets = []) {
  const ticket = tickets.find(
    (entry) =>
      !entry?.generalAdmission &&
      (entry?.sectionNumber || entry?.sectionId || entry?.sectionName)
  )

  if (!ticket) return null

  return {
    section: String(
      ticket.sectionName || ticket.sectionNumber || ticket.sectionId || ''
    ).trim(),
    row: String(ticket.rowNumber || '').trim(),
    seat: String(ticket.seatNumber || '').trim(),
  }
}

export function getOrderFoodLinkContext(order, event) {
  const eventUuid = event?.uuid
  if (!eventUuid) return null

  const seat = getSeatedTicketMenuSeat(order?.tickets)
  if (!seat?.section) return null

  const organizationUuid = event?.organization?.uuid
  const venueUuid = event?.venue?.uuid
  const foodAndBeverageEnabled = event?.organization?.setting?.foodAndBeverage

  if (foodAndBeverageEnabled === false) {
    return null
  }

  // Only link directly when F&B is confirmed; otherwise let the API decide.
  if (foodAndBeverageEnabled === true && organizationUuid && venueUuid) {
    return {
      menuPath: buildEventMenuPath({
        organizationUuid,
        venueUuid,
        sectionName: seat.section,
        row: seat.row,
        seat: seat.seat,
        eventUuid,
      }),
      eventUuid,
      section: seat.section,
      row: seat.row,
      seat: seat.seat,
    }
  }

  return {
    eventUuid,
    section: seat.section,
    row: seat.row,
    seat: seat.seat,
  }
}

export function appendEventQueryParam(searchParams, eventUuid) {
  const params = new URLSearchParams(searchParams?.toString() ?? '')
  if (eventUuid) {
    params.set('event', eventUuid)
  } else {
    params.delete('event')
  }
  return params
}
